/**
 * 萤石设备抓拍：有限并发队列 + 响应 picUrl 解析（设备列表 / 监控墙等共用）
 */
const CAPTURE_CONCURRENCY = 6
/** Java 设备列表 brand 字段：仅「萤石」走 lapp/device/capture */
export const YS_DEVICE_BRAND_EZVIZ = '萤石'

export function isEzvizCaptureBrand (brand) {
  if (brand == null || brand === '') return false
  return String(brand).trim() === YS_DEVICE_BRAND_EZVIZ
}

const captureWaitQueue = []
let captureInflight = 0

function pumpYsCaptureQueue () {
  while (captureInflight < CAPTURE_CONCURRENCY && captureWaitQueue.length > 0) {
    const { fn, resolve, reject } = captureWaitQueue.shift()
    captureInflight++
    Promise.resolve(fn())
      .then(resolve, reject)
      .finally(() => {
        captureInflight--
        pumpYsCaptureQueue()
      })
  }
}

/** @param {() => Promise<unknown>} fn */
export function enqueueYsDeviceCapture (fn) {
  return new Promise((resolve, reject) => {
    captureWaitQueue.push({ fn, resolve, reject })
    pumpYsCaptureQueue()
  })
}

export function parseYs7CapturePicUrl (res) {
  const top = res?.data
  if (!top || typeof top !== 'object') return ''
  const layer = top.data !== undefined ? top.data : top
  const nested = layer?.data !== undefined ? layer.data : layer
  const raw = nested?.picUrl ?? nested?.pic_url ?? layer?.picUrl
  const u = typeof raw === 'string' ? raw.trim() : ''
  return u || ''
}
